var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalidLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FEE4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9166 37.0832L37.0833 28.9166M29.5 23.6666V21.3333M36.5 42.3333V44.6666M23.6666 29.4999H21.3333M42.3333 36.4999H44.6666M24.7332 24.7332L23.0833 23.0833M41.2668 41.2666L42.9167 42.9165M33 39.5995L30.5251 42.0744C28.7027 43.8968 25.7479 43.8968 23.9255 42.0744C22.103 40.2519 22.103 37.2971 23.9255 35.4747L26.4004 32.9998M39.5997 32.9998L42.0746 30.5249C43.897 28.7025 43.897 25.7477 42.0746 23.9253C40.2521 22.1028 37.2973 22.1028 35.4749 23.9253L33 26.4002",
    stroke: "#D92D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#FEF3F2",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidLink);
export default __webpack_public_path__ + "static/media/invalidLink.394af7d7cd461ed879093d5995129dfd.svg";
export { ForwardRef as ReactComponent };